import { combineReducers } from 'redux';

import assetReducer from './asset-reducer';
import userReducer from './user-reducer';
import uploadReducer from './upload-reducer';
import uiReducer from './ui-reducer';

const reducers = combineReducers({
    userProfile: userReducer,
    assetsState: assetReducer,
    currentUpload: uploadReducer,
    ui: uiReducer
});

export default reducers;
